import PlatformNewsletterCheckbox from './PlatformNewsletterCheckbox'

export default PlatformNewsletterCheckbox
